import { render } from "./Form.vue?vue&type=template&id=7e69900c"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"
script.render = render

export default script